import React from 'react';
import {GenericSettingsModal} from 'components/modals';
import TranscriptionTasksSettingsForm from './TranscriptionTasksSettingsForm';
import i18n from 'i18n';

interface TranscriptionTasksSettingsModalProps {
    modalOpen: boolean;
    closeModal: () => void;
    activeTranscriptionTaskId: number;
}

const TranscriptionTasksSettingsModal: React.FC<TranscriptionTasksSettingsModalProps> = React.memo((
    {
        modalOpen,
        closeModal,
        activeTranscriptionTaskId,
    },
) => (
    <GenericSettingsModal
        isOpen={modalOpen}
        onClose={closeModal}
        title={i18n.t('jt_transcription_task.text')}
        entityId={activeTranscriptionTaskId}
        entityIdPropName="transcriptionTaskId"
        FormComponent={TranscriptionTasksSettingsForm}
        includeOnSave={false}
    />
));

export default TranscriptionTasksSettingsModal; 